import React from 'react';
import Carousel from './Carousel';
import Collection from './Collection';
// eslint-disable-next-line
import Offers from './Offers';
import Profile from './Profile';

const Home = () => {
    return (
        <div>
            <Carousel/>
            <Collection/>
            <Profile/>
            {/* <Offers/> */}
        </div>
    );
};

export default Home;